module.exports = __webpack_public_path__ + "img/sprite.24be1706.svg";